import Nullstack from 'nullstack';
export default function IconVectorTriangle({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vector-triangle",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "10",
    y: "4",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "17",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "17",
    y: "17",
    width: "4",
    height: "4",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "6.5",
    y1: "17.1",
    x2: "11.5",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "17.5",
    y1: "17.1",
    x2: "12.5",
    y2: "8"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "19",
    x2: "17",
    y2: "19"
  }), " ");
}